import { ZapparCamera } from '@zappar/zappar-react-three-fiber/lib/index-standalone';
import React, { useCallback, useRef, FunctionComponent } from 'react';
import { Jute } from '..';
import { useCameraIsUserFacing } from '../hooks/general';
import { Camera } from '@zappar/zappar-threejs';
import { useGetActiveTrackingType } from './hoc/hocCustomHooks';
import { ITrackingTypes } from './r3f-components/component-data-structure';

export let zapparCameraInstance: Camera | undefined;

const ZapparCameraWrapper: FunctionComponent = () => {
	const isUserFacing = useCameraIsUserFacing();
	const firstFrameHasRun = useRef(false);
	const activeTrackingType = useGetActiveTrackingType()

	// ensure that on first frame is fired off only once (it has fired off more than once in the past)
	const onFirstFrame = useCallback(() => {
		if (firstFrameHasRun.current) return;
		Jute.firstCameraFrame?.();
		firstFrameHasRun.current = true;
	}, []);

	return (
		// @ts-ignore
		<ZapparCamera
			ref={self => {
				if (!self) return;
				(self as Camera).name = 'zappar-camera';
				zapparCameraInstance = self;
			}} 
			dispose={null}
			renderPriority={-1} 
			environmentMap={activeTrackingType !== ITrackingTypes.content360}
			poseMode="anchor-origin" 
			// poseMode="attitude" 
			// poseMode={Jute.isAppClip && activeTrackingType === ITrackingTypes.world ? "anchor-origin" : "attitude"}
			onFirstFrame={onFirstFrame} 
			userFacing={isUserFacing} 
		/>
	);
};

ZapparCameraWrapper.displayName = 'ZapparCameraWrapper';
export default React.memo(ZapparCameraWrapper);
